import { Button, Header, Message, Segment, Icon } from "@/components/bp/bp-ui";
import { Frown } from 'lucide-react';

const BPPageNotFound: React.FC = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon><Frown size={50} /></Icon>
                Page Not Found
            </Header>
            <div style={{textAlign: "center"}}>
                <p>Sorry, the page you are looking for does not exist.</p>
            </div>
        </Segment>
    );
};

export default BPPageNotFound;